<template>
    <div style="position: relative">
        <label
            v-if="placeholder"
            :class="['multiline-label', {'custom-label-error': shouldShowError(name) }]"
            @onclick="onClickTheLabel($event)"
            v-html="computedPlaceholder"
        ></label>
        <component
            :is="tag"
            :type="type"
            :name="name"
            :class="[extraClass, 'multiline-input', {'custom-input-error': shouldShowError(name) }]"
            :value="value"
            :maxlength="maxLength"
            class="form-control p-input"
            @click="onClickTheInput($event)"
            @blur="onBlurTheInput($event)"
            @change="changeInput($event)"
            @input="updateInput($event)"
            @keyup="$emit('keyup')"
            @focus="$emit('focus')"
            ref="customInput"></component>
    </div>
</template>

<script>
export default {
    name: 'PInput',
    inject: ['$validator'],
    props: [
        'tag',
        'type',
        'name',
        'extraClass',
        'placeholder',
        'validation',
        'label',
        'value',
        'maxLength'
    ],
    computed: {
        newLabel() {
            return this.label.replace('*', '<span style="color: red;">*</span>')
        },
        computedPlaceholder() {
            if (this.value.length === 0) {
                return this.placeholder
            }

            return '';
        }
    },
    methods: {
        updateInput(e) {
            this.$emit('input', e.target.value)
        },
        changeInput(e) {
            this.$emit('change', e.target.value)
        },
        shouldShowError(fieldName) {
            return undefined !== this.errors.first(fieldName)
        },
        onBlurTheInput(event) {
            const value = event.target.value;

            if (value === '') {
                event.target.previousElementSibling.classList.remove('d-none')
            }

            this.$emit('blur')
        },
        onClickTheInput(event) {
            event.target.previousElementSibling.classList.add('d-none')

            this.$emit('click')
        },
        onClickTheLabel(event) {
            event.target.classList.add('d-none')
            event.target.nextSibling.focus()

            this.$emit('click')
        }
    },
    updated(fieldName) {
        this.$refs.customInput.value = this.value
    }
}
</script>

<style scoped>
.multiline-label {
    pointer-events: none;
    cursor: text;
}

input.multiline-input {
}

.custom-input-error {
    border: 1px solid #ed1c24;
}

.custom-label-error {
    color: #ed1c24;
}
</style>
